import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

//Miscellaneous
import moment from "moment";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { Fade, Reveal } from "react-awesome-reveal";
import { keyframes } from "@emotion/react";
import Swal from "sweetalert2";

//Components
import DateTimePicker from "../../components/DateTimePicker/DateTimePicker";
import DataTable from "../../components/Datatable/DataTable";
import SideBar from "../../components/Sidebar/Sidebar";
import Button from "../../components/Button/Button";
import CryptoDepositModal from "../../components/CryptoDepositModal/CryptoDepositModal";
import { isDesktop } from "react-device-detect";
import StringInput from "../../components/Input/StringInput/StringInput";
import { default as ReactSelect } from "react-select";

//Icons
import { Icon } from "@iconify/react";

// Actions
import * as actions from "../../store/ducks/profile/actions";
// import { getCryptoTransStatus } from "../../store/ducks/deposit/actions";
import MobileMemberManagement from "./MobileMemberManagement";

const filterCategories = [
    { id: "filterDeposit", value: "deposit", label: "deposit" },
    { id: "filterWithdrawal", value: "withdrawal", label: "withdrawal" },
    { id: "filterAgentPayout", value: "agent-payout", label: "agent-payout" },
    { id: "filterAgentTransfer", value: "agent-transfer", label: "agent-transfer" },
];

const filterBet = [
    { id: "filterAll", value: "all", label: "All" },
    { id: "filterBet", value: "bet", label: "Bet" },
    { id: "filterNoBet", value: "no-bet", label: "No-bet" },
];

const filterDate = [
    { id: "filterToday", value: "0", label: "today" },
    { id: "filterYtd", value: "1", label: "yesterday" },
    { id: "filter7Day", value: "7", label: "last-7-days" },
    { id: "filter30Days", value: "30", label: "last-30-days" },
];
class MemberManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            start_date: moment().format("YYYY-MM-DD"),
            end_date: moment().format("YYYY-MM-DD"),
            transaction_type: "deposit",
            currentFilterDate: 0,
            transaction_date: "",

            /* datatables / pagination */
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            totalRecords: 0,

            /* api result array */
            data: [],

            /* skeleton loading */
            loading: true,
            dropdownLoading: true,
            dates: null,

            /* crypto */
            openCryptoDepositModal: false,
            input: {
                amount: "",
            },
            cryptoPayment: "pending",
            refCode: "",
            txid: "",
            exchangeRate: "",
            usdtAmt: "",
            channel: "",
            type: "",

            time: {},
            timer: 0,
            seconds: 900,
            expiredDateTime: "",

            /* mobile */
            showDateSelect: false,
            showDate: "",
            selectedDate: "",

            spin: false,

            username: "",
            filterBet: "",
            countryFilter: "",
            countryList: [],
        };
        this.onInputChange = this.onInputChange.bind(this);
    }

    componentDidMount() {
        const listingArr = this.getFilterArray();
        this.props.funcGetList(listingArr);
        // Fetch country list
        this.props.funcGetCountryList();
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { t } = this.props;

        // Handle country list response
        if (nextProps.countryList !== this.props.countryList && nextProps.countryList !== undefined) {
            if (nextProps.countryList.responseCode === 200) {
                let countryOptions = [];
                
                // Handle new endpoint response (data.countries)
                if (nextProps.countryList.data && nextProps.countryList.data.countries) {
                    countryOptions = nextProps.countryList.data.countries.map(country => ({
                        value: country.id,
                        label: country.title || country.shortcode,
                        id: country.id
                    }));
                }
                // Handle old endpoint response (country array with CountryResource format)
                else if (nextProps.countryList.country) {
                    countryOptions = nextProps.countryList.country.map(country => ({
                        value: country.countryId,
                        label: country.countryName || country.countryShortCode,
                        id: country.countryId
                    }));
                }
                
                this.setState({
                    countryList: countryOptions,
                });
            }
        }

        if (nextProps.rs !== this.props.rs && nextProps.rs !== undefined) {
            if (nextProps.rs.responseCode === 200 && nextProps.rs.msgType === "success") {
                this.setState({
                    data: nextProps.rs.data.result.row,
                    totalRecords: nextProps.rs.data.result.pagination.total_record,
                    loading: false,
                    disableSearchButton: false,
                });
            } else {
                let msg = null;
                msg = "<div>";
                nextProps.rs.message.forEach((val) => {
                    msg += "<p>" + val + "</p>";
                });
                msg += "</div>";

                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                    icon: "error",
                    title: t("global.sorry"),
                    html: msg,
                    showConfirmButton: true,
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                                container: "swal-mobile-container sorry",
                                icon: "swal-sorry-icon",
                            }
                        : [],
                }).then(() => {
                    this.setState({
                        loading: false,
                        disableSearchButton: false,
                    });
                });
            }
        }

        return true;
    }

    imageImport = (r) => {
        let images = {};
        r.keys().map((item, index) => {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    };

    onInputChange = (event) => {
        if (event.target.id === "transaction_date") {
            const date = event.target.value !== "" ? event.target.value.split(" - ") : null;
            this.setState({
                start_date: date[0] ? moment(date[0]).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
                end_date: date[1] ? moment(date[1]).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
                transaction_date: event.target.value,
            });

            const startDate = moment(this.state.start_date);
            const endDate = moment(this.state.end_date);
            const diff = endDate.diff(startDate, "days");

            // Only allow to get data between 3 months
            if (diff > 92) {
                this.setState({
                    disableSearchButton: true,
                });
            } else {
                this.setState({
                    disableSearchButton: false,
                });
            }
        } else {
            this.setState(
                {
                    [event.target.name]: event.target.value,
                },
                () => {
                    this.searchHandler();
                }
            );
        }
    };

    searchHandler = () => {
        this.setState(
            {
                activePage: 1,
                data: [],
                loading: true,
                disableSearchButton: true,
            },
            () => {
                const listingArr = this.getFilterArray();
                this.props.funcGetList(listingArr);
            }
        );
    };

    filterDayRange = (val) => {
        // let days = Number(event.target.value);
        let days = val;
        let startDate = moment().subtract(days, "days").format("YYYY-MM-DD");
        let endDate = moment().format("YYYY-MM-DD");
        let transactionDate = `${moment(startDate).format("MM/DD/YYYY")} - ${moment(endDate).format("MM/DD/YYYY")}`;

        this.setState(
            {
                start_date: startDate,
                end_date: endDate,
                transaction_date: transactionDate,
                filterRange: days,
            },
            () => {
                let startDate = moment(this.state.start_date);
                let endDate = moment(this.state.end_date);
                let dayRange = endDate.diff(startDate, "days");
                let disableButton = null;
                if (!startDate.isSameOrBefore(endDate) || !endDate.isSameOrAfter(startDate) || dayRange > 92) {
                    disableButton = true;
                } else {
                    disableButton = false;
                    // const listingArr = this.getFilterArray();
                    // this.props.funcGetList(listingArr);
                }

                this.setState({
                    disableSearchButton: disableButton,
                });

                this.searchHandler();
            }
        );
    };

    getFilterArray = () => {
        const listingArr = {};
        listingArr.page = this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.start_date = this.state.start_date;
        listingArr.end_date = this.state.end_date;
        listingArr.lang_id = this.props.currentUser.language_id;
        listingArr.agent_id = this.props.currentUser.id;
        listingArr.search_username = this.state.username;
        listingArr.bet_status = this.state.filterBet;
        listingArr.country_id = this.state.countryFilter;
        return listingArr;
    };

    datatablesChangeHandler = (val, tab, act) => {
        this.setState(
            {
                data: [],
                loading: true,
                [act]: val,
            },
            () => {
                const listingArr = this.getFilterArray();
                this.props.funcGetList(listingArr);
            }
        );
    };

    //Mobile//
    toggleShowDateSelect = (e, show) => {
        if (this.state.showDateSelect === false) {
            document.body.classList.add("modal-open");
        } else {
            document.body.classList.remove("modal-open");
        }

        this.setState({
            showDateSelect: !this.state.showDateSelect,
        });

        const startDate = moment(this.state.start_date);
        const endDate = moment(this.state.end_date);
        const diff = endDate.diff(startDate, "days");

        if (show === "startDate") {
            this.setState({
                showDate: "startDate",
                selectedDate: this.state.start_date,
                disableSearchButton: diff > 30 ? true : false,
            });
        } else if (show === "endDate") {
            this.setState({
                showDate: "endDate",
                selectedDate: this.state.end_date,
                disableSearchButton: diff > 30 ? true : false,
            });
        }

        this.setState({
            showDate: show,
            selectedDate: show === "startDate" ? this.state.start_date : this.state.end_date,
            disableSearchButton: diff > 92 || !startDate.isSameOrBefore(endDate),
        });
    };

    onChangeDateHandler = (value) => {
        let start_date = this.state.start_date;
        let end_date = this.state.end_date;

        if (this.state.showDate === "startDate") {
            start_date = `${value.years}-${value.months}-${value.days}`;
        } else if (this.state.showDate === "endDate") {
            end_date = `${value.years}-${value.months}-${value.days}`;
        }

        const startDate = moment(start_date);
        const endDate = moment(end_date);
        const diff = endDate.diff(startDate, "days");

        this.setState({
            start_date,
            end_date,
            disableSearchButton: diff > 92 || !startDate.isSameOrBefore(endDate),
        });
    };


    onChangeFilterDateHandler = (value, e) => {
        this.setState({
            currentFilterDate: value,
        });
    };

    onResetHandler = () => {
        this.setState(
            {
                username: "",
                filterBet: "",
                countryFilter: "",
                transaction_type: "deposit",
                currentFilterDate: 0,
                start_date: "",
                end_date: "",
                transaction_date: "",
                spin: true,
            },
            () => {
                const listingArr = this.getFilterArray();
                this.props.funcGetList(listingArr);
            }
        );

        setTimeout(() => this.setState({ spin: false }), 2000);
    };

    cancelHandler = (e, id) => {
        e.preventDefault();
        const { t } = this.props;
        Swal.fire({
            iconHtml: !isDesktop ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">' : "",
            title: t("global.would-you-like-to-proceed") + "?",
            icon: "warning",
            confirmButtonText: t("global.confirm"),
            showDenyButton: true,
            denyButtonText: t("global.cancel"),
            customClass: !isDesktop
                ? {
                      container: "swal-mobile-container confirmation",
                      icon: "swal-confirmation-icon",
                  }
                : [],
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
                let data = {};
                data.id = id;
                this.props.funcCancelWithdraw(data);
            }
        });
    };

    openCryptoModalHandler = (reference_code) => {
        let data = {};
        data.reference_code = reference_code;
        this.props.funcCryptoTransStatus(data);

        this.setState({
            openCryptoDepositModal: !this.state.openCryptoDepositModal,
        });

        clearInterval(this.timer);
    };

    countDown = () => {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;

        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        // Check if we're at zero.
        if (seconds === 0) {
            clearInterval(this.timer);
        }
    };

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            h: hours,
            m: minutes,
            s: seconds.toString().padStart(2, "0"),
        };

        return obj;
    }

    handleUsername = (e) => {
        this.setState({
            username: e.target.value,
        });
    };

    handleFilterBetChange = (e) => {
        this.setState({
            filterBet: e.value,
        });
    };

    handleCountryFilterChange = (e) => {
        this.setState({
            countryFilter: e ? e.value : "",
        });
    };

    render() {
        const { t } = this.props;
        const icons = this.imageImport(require.context("../../assets/images/deposit/icons", false, /\.(png|jpe?g|svg)$/));
        const resetIcon = this.imageImport(require.context("../../assets/images/icons", false, /\.(png|jpe?g|svg)$/));

        let rsData = [];
        const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };
        const columns = [
            { text: t("member-management.username"), dataField: "username" },
            { text: t("global.currency"), dataField: "currency" },
            { text: t("global.country"), dataField: "country" },
            { text: t("member-management.deposit"), dataField: "deposit" },
            { text: t("member-management.withdrawal"), dataField: "withdrawal" },
            { text: t("member-management.total-win-lose"), dataField: "total_win_lose" },
            { text: t("member-management.last-login-time"), dataField: "last_login_time" },
            { text: t("member-management.register-time"), dataField: "register_time" },
            // { text: t("global.action"), dataField: "action" },
        ];

        if (this.state.data) {
            rsData = this.state.data.map((val, idx) => {
                return {
                    no: idx,
                    username: val.username,
                    currency: 'USD',
                    country: val.country_title || '-',
                    deposit: new Intl.NumberFormat("en-US", num_format).format(val.total_deposit_usd),
                    withdrawal: new Intl.NumberFormat("en-US", num_format).format(val.total_withdrawal_usd),
                    total_win_lose: new Intl.NumberFormat("en-US", num_format).format(val.total_win_lose_usd),
                    last_login_time: val.last_login,
                    register_time: val.register_date,
                    // action: actionVal,
                };
            });
        }

        const fadeUp = keyframes`
            from {
            opacity: 0;
            transform: translate3d(0, 50px ,0);
            }

            to {
            opacity: 1;
            transform: translate3d(0, 0, 0);
            }
        `;

        return (
            <Auxiliary>
                <CryptoDepositModal {...this.state} {...this.props} toggleCryptoDepositModalHandler={this.openCryptoModalHandler} />

                {isDesktop ? (
                    <section className="pf-dashboard">
                        <div className="x-container">
                            <SideBar />
                            <Reveal className="pf-fade-col" keyframes={fadeUp} duration={1000} triggerOnce>
                                <div className="row g-3">
                                    <div className="col-12">
                                        <div className="pd-card-col">
                                            <h4 className="mb-2">{t("member-management.title")}</h4>
                                            <div className="pd-content">
                                                <div className="filters-col">
                                                    <div className="filters-tp-panel">
                                                        <div className="filters-tp-col">
                                                            <label className="col-form-label">{t("member-management.username")}:</label>
                                                            {/* <label className="col-form-label">Member Account :</label> */}
                                                                <div className="filters-group">
                                                                <StringInput
                                                                        className={`form-control w-border-r`}
                                                                        // className={`form-control ${this.state.username === "" ? "is-invalid is-invalid" : "is-valid is-valid"}`}
                                                                        id="username"
                                                                        placeholder={t("member-management.username")}
                                                                        // placeholder='Member'
                                                                        type="text"
                                                                        autoComplete="off"
                                                                        onChange={(e) => this.handleUsername(e)}
                                                                        //  onBlur={this.handleCheckUsername}
                                                                        value={this.state.username}
                                                                        //  errorMsg={this.state.errorMsg.username || ""}
                                                                        //  formError={this.state.formError}
                                                                    />
                                                                </div>
                                                                </div>

                                                            <div className="filters-tp-col">
                                                                <label className="col-form-label">{t("member-management.bet-or-not")}:</label>
                                                                    <div className="filters-group" style={{width:"8rem"}}>
                                                                            <ReactSelect
                                                                                classNamePrefix="react-select"
                                                                                className="w-100"
                                                                                // placeholder={t("banking-details.select-bank")}
                                                                                name="edit_bank_name"
                                                                                options={filterBet}
                                                                                onChange={this.handleFilterBetChange}
                                                                                // value={(this.state.edit_bank_key !== null) ? editMemberBankArray[this.state.edit_bank_key] : ''}
                                                                                // formatOptionLabel={(item) => (
                                                                                //     <>
                                                                                //         <img src={
                                                                                //             (bankImg[`${item.icon.toLowerCase()}.svg`] !== undefined)
                                                                                //                 ?
                                                                                //                 bankImg[`${item.icon.toLowerCase()}.svg`]
                                                                                //                 :
                                                                                //                 bankImg["default-bank-icon.png"]
                                                                                //         } alt={item.label} />
                                                                                //         <p>{item.label}</p>
                                                                                //     </>
                                                                                // )}
                                                                            />
                                                                    </div>
                                                            </div>

                                                            <div className="filters-tp-col">
                                                                <label className="col-form-label">{t("global.country")}:</label>
                                                                    <div className="filters-group" style={{width:"8rem"}}>
                                                                            <ReactSelect
                                                                                classNamePrefix="react-select"
                                                                                className="w-100"
                                                                                placeholder={t("global.country")}
                                                                                name="country_filter"
                                                                                options={this.state.countryList}
                                                                                onChange={this.handleCountryFilterChange}
                                                                                isClearable={true}
                                                                                value={this.state.countryList.find(option => option.value === this.state.countryFilter) || null}
                                                                            />
                                                                    </div>
                                                            </div>
                                                    </div>
                                                    <div className="filters-bt-panel">
                                                    <div className="filters-bt-col">
                                                            <label className="col-form-label">{t('history.date')}:</label>
                                                            {/* <label className="col-form-label">Statistics Time:</label> */}
                                                            <div className=" input-group right">
                                                            <DateTimePicker
                                                                    id="transaction_date"
                                                                    name="transaction_date"
                                                                    className="form-control"
                                                                    autoUpdateInput={true}
                                                                    autoApply={true}
                                                                    format="MM/DD/YYYY"
                                                                    value={this.state.transaction_date}
                                                                    onChange={this.onInputChange}
                                                                />
                                                                <span className="input-group-text">
                                                                    <Icon icon="uil:calendar-alt" />
                                                                </span>
                                                                {/* {filterDate &&
                                                                    filterDate.map((item, index) => (
                                                                        <div className="form-check form-check-inline filter" key={index}>
                                                                            <input
                                                                                className="btn-check"
                                                                                type="radio"
                                                                                name="filterDate"
                                                                                id={item.id}
                                                                                value={item.value}
                                                                                defaultChecked={index === 0}
                                                                                checked={index === this.state.currentFilterDate}
                                                                                onClick={(e) => this.onChangeFilterDateHandler(index, e)}
                                                                            />
                                                                            <label className="btn form-check-label" htmlFor={item.id} style={{ maxWidth: '75px' }} onClick={() => this.filterDayRange(item.value)}>
                                                                                {t(`history.${item.label}`)}
                                                                            </label>
                                                                        </div>
                                                                    ))} */}
                                                            </div>
                                                        </div>
                                                        <div className="filters-bt-col">
                                                            {/* <label className="col-form-label">{t("history.time")}:</label> */}
                                                            {/* <label className="col-form-label">Register Time:</label> */}
                                                            {/* <div className="input-group right">
                                                                <DateTimePicker
                                                                    id="transaction_date"
                                                                    name="transaction_date"
                                                                    className="form-control"
                                                                    autoUpdateInput={true}
                                                                    autoApply={true}
                                                                    format="MM/DD/YYYY"
                                                                    value={this.state.transaction_date}
                                                                    onChange={this.onInputChange}
                                                                />
                                                                <span className="input-group-text">
                                                                    <Icon icon="uil:calendar-alt" />
                                                                </span>
                                                            </div> */}
                                                            <Button
                                                                typeButton="button"
                                                                classValue="btn btn-gradient-blue"
                                                                idValue="search"
                                                                buttonName={t("global.check")}
                                                                clicked={() => this.searchHandler(this.state.transaction_type)}
                                                                disabled={this.state.disableSearchButton}
                                                            />
                                                            <div className="reset-btn">
                                                                <img
                                                                    className={`${this.state.spin ? "spin" : ""} `}
                                                                    src={resetIcon["rotate-icon.svg"]}
                                                                    alt="reset"
                                                                    onClick={this.onResetHandler}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="pd-card-col">
                                            <Fade duration={1000} triggerOnce>
                                                <DataTable
                                                    keyField="no"
                                                    data={rsData}
                                                    columns={columns}
                                                    activePage={this.state.activePage}
                                                    limit={this.state.limit}
                                                    totalItems={this.state.totalRecords}
                                                    paginationHandler={(val) => this.datatablesChangeHandler(val, "deposit", "activePage")}
                                                    // sizePerPageHandler={(val) => this.datatablesChangeHandler(val, 'deposit', "limit")}
                                                    loading={this.state.loading}
                                                    hideSearchBar={true}
                                                    hideTotalRecords={true}
                                                    classValue="pd-table"
                                                    component="betting-history"
                                                />
                                            </Fade>
                                        </div>
                                    </div>
                                </div>
                            </Reveal>
                        </div>
                    </section>
                ) : (
                    <MobileMemberManagement
                        filterCategories={filterCategories}
                        filterDate={filterDate}
                        onInputChange={this.onInputChange}
                        filterDayRange={this.filterDayRange}
                        icons={icons}
                        num_format={num_format}
                        rsData={rsData}
                        columns={columns}
                        searchHandler={this.searchHandler}
                        datatablesChangeHandler={this.datatablesChangeHandler}
                        onChangeDateHandler={this.onChangeDateHandler}
                        toggleShowDateSelect={this.toggleShowDateSelect}
                        onResetHandler={this.onResetHandler}
                        onChangeFilterDateHandler={this.onChangeFilterDateHandler}
                        {...this.state}
                        {...this.props}
                        handleUsername={this.handleUsername}
                        handleFilterBetChange={this.handleFilterBetChange}
                        handleCountryFilterChange={this.handleCountryFilterChange}
                        filterBet={filterBet}
                        countryList={this.state.countryList}
                    />
                )}
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = (state) => {
    return {
        rs: state.profile.get_member_result,
        currentUser: state.currentUser.data,
        countryList: state.profile.country_list,
    };
};

//Using the redux calling api methods
const mapDispatchToProps = (dispatch) => {
    return {
        funcGetList: (filter) => dispatch(actions.getMember(filter)),
        funcGetCountryList: () => dispatch(actions.getCountryList()),
    };
};

// Connect redux
export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(MemberManagement));
